import React, { useState } from "react";
import { sensorTypes } from "../data/equipmentTypes";

export default function EquipmentCard({ equipment, eligible, onStageChange, onAttachSensor, onDetachSensor, onRemove }) {
  const [showSensorDropdown, setShowSensorDropdown] = useState(false);
  const [showMenu, setShowMenu] = useState(false);

  return (
    <div className={`equipment-card ${equipment.stage}`}>
      <div className="equipment-header">
        <div className="equipment-title">
          <span className="status-dot" />
          {equipment.label}
        </div>
        <div className="stage-control">
          {["veg", "flower", "dry"].map((s) => (
            <button
              key={s}
              className={`stage-button ${s} ${equipment.stage === s ? "active" : ""}`}
              onClick={() => onStageChange(equipment.id, s)}
              aria-pressed={equipment.stage === s}
            >
              {s.charAt(0).toUpperCase() + s.slice(1)}
            </button>
          ))}
        </div>
      </div>

      {equipment.sensors.map((sensor) => (
        <div key={sensor.type} className="sensor-slot">
          <span className="sensor-info">
            <span className="sensor-dot" />
            {sensorTypes[sensor.type]?.label || sensor.type} — connected
          </span>
          <button className="sensor-detach" onClick={() => onDetachSensor(equipment.id, sensor.type)} aria-label="Detach sensor">
            ×
          </button>
        </div>
      ))}

      {eligible.length > 0 && (
        <div className="add-sensor-dropdown">
          {showSensorDropdown ? (
            <select
              autoFocus
              defaultValue=""
              onChange={(e) => { onAttachSensor(equipment.id, e.target.value); setShowSensorDropdown(false); }}
              onBlur={() => setShowSensorDropdown(false)}
            >
              <option value="" disabled>Select sensor…</option>
              {eligible.map((s) => (
                <option key={s} value={s}>{sensorTypes[s]?.label || s}</option>
              ))}
            </select>
          ) : (
            <button className="add-sensor-btn" onClick={() => setShowSensorDropdown(true)}>+ Add Sensor</button>
          )}
        </div>
      )}

      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 8, position: "relative" }}>
        <button className="overflow-menu-btn" onClick={() => setShowMenu(!showMenu)}>⋯ ⚙</button>
        {showMenu && (
          <div style={{ position: "absolute", top: "100%", right: 0, background: "#fff", border: "1px solid #d1d5db", borderRadius: 6, padding: 4, zIndex: 10 }}>
            <button
              style={{ display: "block", width: "100%", padding: "6px 12px", border: "none", background: "none", cursor: "pointer", color: "#ef4444", fontSize: 13, textAlign: "left" }}
              onClick={() => { onRemove(equipment.id); setShowMenu(false); }}
            >
              Remove
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
